import app from 'flarum/forum/app';

/**
 * The dashboard's tab registry.
 *
 * The tabs span extensions — monitors and status pages come from here, Chirp
 * from lr-services — but neither should import the other: Chirp can be
 * disabled without taking the dashboard down with it. So each extension
 * registers its own tabs and the shell renders whatever is there.
 *
 * It hangs off `app` rather than a module-level array because extensions are
 * separate bundles: a module-level list would give each one its own copy.
 * Load order is not guaranteed either, so every caller initialises it.
 */

export function registerDashboardTab(tab) {
  const holder = app;
  const all = holder.lrDashboardTabs ??= [];
  const at = all.findIndex(t => t.key === tab.key);
  if (at >= 0) {
    all[at] = tab;
    return;
  }
  all.push(tab);
}
export function dashboardTabs() {
  const holder = app;
  return (holder.lrDashboardTabs ?? []).filter(t => !!app.routes[t.route]).filter(t => {
    try {
      return t.visible ? t.visible() : true;
    } catch (e) {
      return false;
    }
  }).slice().sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100));
}
flarum.reg.add('linkrobins-lr-monitoring', 'dashboard', { registerDashboardTab: registerDashboardTab,dashboardTabs: dashboardTabs, });